import { ExtendedCategory } from "../../../store/Catalogs/types";
import { Skeleton } from "../../../components/ui/skeleton";
import { cn } from "@/dentlab/src/lib/utils";
import { Folder, FolderOpen } from "lucide-react";

interface CategoriesListProps {
	categories: ExtendedCategory[];
	selectedCategoryId: string | null;
	isLoading: boolean;
	onSelectCategory: (categoryId: string | null) => void;
}

export const CategoriesList: React.FC<CategoriesListProps> = ({
	categories,
	selectedCategoryId,
	isLoading,
	onSelectCategory,
}) => {
	if (isLoading) {
		return (
			<div className="p-3 space-y-1">
				{[1, 2, 3, 4].map((i) => (
					<Skeleton key={i} className="h-8 w-full" />
				))}
			</div>
		);
	}

	if (categories.length === 0) {
		return (
			<div className="p-4 text-center text-gray-500 text-sm">
				Keine Kategorien verfügbar
			</div>
		);
	}

	// Show "All" option first
	return (
		<div className="p-2">
			<button
				onClick={() => onSelectCategory(null)}
				className={cn(
					"w-full px-3 py-2 text-left rounded-md transition-colors text-sm",
					"hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-1",
					selectedCategoryId === null
						? "bg-blue-50 text-blue-700 hover:bg-blue-100"
						: "text-gray-700"
				)}
			>
				<div className="flex items-center space-x-2">
					<Folder className="w-4 h-4 text-gray-400" />
					<span className="font-medium">Alle Leistungen</span>
				</div>
			</button>

			<div className="mt-2 space-y-1">
				{categories.map((category) => (
					<button
						key={category.id}
						onClick={() => onSelectCategory(category.id)}
						disabled={category.is_deactivated}
						className={cn(
							"w-full px-3 py-2 text-left rounded-md transition-colors text-sm",
							"hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-1",
							selectedCategoryId === category.id
								? "bg-blue-50 text-blue-700 hover:bg-blue-100"
								: "text-gray-700",
							category.is_deactivated && "opacity-50 cursor-not-allowed"
						)}
					>
						<div className="flex items-center justify-between">
							<div className="flex items-center space-x-2 min-w-0">
								{selectedCategoryId === category.id ? (
									<FolderOpen className="w-4 h-4 text-blue-600 flex-shrink-0" />
								) : (
									<Folder className="w-4 h-4 text-gray-400 flex-shrink-0" />
								)}
								<span className={cn(
									"truncate",
									category.is_deactivated && "line-through"
								)}>
									{category.name}
								</span>
							</div>
							{category.is_custom && (
								<span className="text-xs text-gray-400 ml-2 flex-shrink-0">
									Eigene Kategorie
								</span>
							)}
						</div>
					</button>
				))}
			</div>
		</div>
	);
};